module.exports = __webpack_public_path__ + "img/3.3f81c1d5.png";